import axios from 'axios';

export default class StatusService {

    public static selectList(model) {
        return axios.get('/' + model + '/statusSelectList');
    }

}
